import { useEffect, useState } from "react";
import { WifiSlash, ArrowClockwise } from "@phosphor-icons/react";

export function useOnline() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
}

export function Spinner({ size = 36 }) {
  return (
    <span
      className="inline-block rounded-full border-[3px] border-[#E8E5DF] border-t-[#C85A17] animate-spin"
      style={{ width: size, height: size }}
      aria-hidden
    />
  );
}

export function PageLoader({ label = "Chargement…" }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 text-[#5C6B64]" data-testid="page-loader" role="status">
      <Spinner />
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
}

export function SkeletonCard({ lines = 2 }) {
  return (
    <div className="card-surface p-5 animate-pulse" aria-hidden>
      <div className="h-5 w-2/3 rounded bg-[#E8E5DF]" />
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="h-3.5 rounded bg-[#E8E5DF] mt-3" style={{ width: `${55 - i * 12}%` }} />
      ))}
    </div>
  );
}

export function SkeletonList({ count = 3, lines = 2 }) {
  return (
    <div className="space-y-4" data-testid="skeleton-list">
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} lines={lines} />)}
    </div>
  );
}

export function OfflineScreen() {
  return (
    <div className="fixed inset-0 z-[70] bg-[#F9F6F0] flex flex-col items-center justify-center text-center px-6 safe-top safe-bottom" data-testid="offline-screen">
      <div className="w-20 h-20 rounded-3xl bg-[#1E3F33] flex items-center justify-center">
        <WifiSlash size={40} weight="duotone" className="text-white" />
      </div>
      <h1 className="font-display font-bold text-2xl mt-6 text-[#1A1F1C]">Pas de connexion</h1>
      <p className="text-[#5C6B64] mt-2 max-w-xs">
        Vérifiez votre connexion Internet ou vos données mobiles. L'application reprendra automatiquement dès le retour du réseau.
      </p>
      <button onClick={() => window.location.reload()} className="btn-primary mt-8" data-testid="offline-retry">
        <ArrowClockwise size={18} /> Réessayer
      </button>
    </div>
  );
}
